import React, { useState } from "react";
import "./ItemCSS.css";
import { FaShoppingCart, FaStar } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroImage from "../assets/brik.png";
import hunting from "../assets/hunt4.png";
import bigphoneStand from "../assets/bigphonestand.png";
import brikCard from "../assets/brikcard.png";
import batterypack from "../assets/batterypack.png";
import brikwallet from "../assets/walletpic.png";
// Sample product data
const product = {
  id: 2,
  name: "Utility Card",
  description:
    "Compact multi-tool card designed to tackle everyday tasks with ease. Features built-in wrenches, a smartphone stand, a can opener, a ruler, and more—crafted for ultimate convenience in a slim, wallet-friendly design. Perfect for on-the-go problem-solving and quick fixes.",
  price: 10.99,
  originalPrice: 250.0,
  link: "/utility",
  discount: 50,
  images: [
    require("../assets/utility.png"),
    require("../assets/utility1.png"),
  ],
};

// Sample Reviews
const initialReviews = [
  { name: "John Doe", rating: 5, comment: "Great quality! Highly recommend." },
  { name: "Jane Smith", rating: 4, comment: "Nice design, but shipping took a while." },
  { name: "John Doe", rating: 5, comment: "Great quality! Highly recommend." },
  { name: "Jane Smith", rating: 4, comment: "Nice design, but shipping took a while." },
  { name: "John Doe", rating: 5, comment: "Great quality! Highly recommend." },
  { name: "Jane Smith", rating: 4, comment: "Nice design, but shipping took a while." },
  { name: "John Doe", rating: 5, comment: "Great quality! Highly recommend." },
  { name: "Jane Smith", rating: 4, comment: "Nice design, but shipping took a while." },
];

const Utility = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [reviews, setReviews] = useState(initialReviews);
  const [newReview, setNewReview] = useState({ name: "", rating: 5, comment: "" });
  const [notification, setNotification] = useState(""); // Notification state

  const handleQuantityChange = (change) => {
    setQuantity((prev) => Math.max(prev + change, 1));
  };

  const addToCart = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const updatedCart = [...cart, { ...product, quantity }];
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setNotification("Added to cart!");
    setTimeout(() => setNotification(""), 3000);
  };

  const handleReviewSubmit = (e) => {
    e.preventDefault();
    if (!newReview.name || !newReview.comment) return;
    setReviews([...reviews, newReview]);
    setNewReview({ name: "", rating: 5, comment: "" });
  };

  return (
    <div>
      <Header />
      {/* Notification shown in the center */}
      {notification && <div className="notification">{notification}</div>}
      <div className="product-page1">
        <div className="product-container1">
          {/* Image Gallery */}
          <div className="product-gallery1">
            <img src={product.images[currentImage]} alt="Product" className="main-image1" />
            <div className="thumbnails1">
              {product.images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  className={`thumbnail1 ${index === currentImage ? "active1" : ""}`}
                  onClick={() => setCurrentImage(index)}
                  alt="Thumbnail"
                />
              ))}
            </div>
          </div>

          {/* Product Details */}
          <div className="product-details1">
            <span className="company-name1">The Brik</span>
            <h1 className="product-title1">{product.name}</h1>
            <p className="description1">{product.description}</p>

            {/* Price Section */}
            <div className="price-section1">
              <div className="price1">
                <span className="current-price1">${product.price.toFixed(2)}</span>
              </div>
            </div>

            <div className="cart-actions1">
              {/* Quantity Selector */}
              <div className="quantity-selector1">
                <button onClick={() => handleQuantityChange(-1)}>-</button>
                <span>{quantity}</span>
                <button onClick={() => handleQuantityChange(1)}>+</button>
              </div>

              {/* Add to Cart */}
              <button className="add-to-cart1" onClick={addToCart}>
                <FaShoppingCart /> Add to cart
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Reviews Section */}
      {/* <div className="reviews-section">
        <div className="reviews-header">
          <h2>Customer Reviews</h2>
          <div className="average-rating">
            {reviews.length > 0
              ? (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1)
              : "No Reviews Yet"}/5
          </div>
        </div>

        <div className="reviews-list-container">
          <div className="reviews-list">
            {reviews.map((review, index) => (
              <div key={index} className="review-item">
                <div className="review-header">
                  <strong>{review.name}</strong>
                  <span className="review-stars">
                    {review.rating}/5
                  </span>
                </div>
                <p className="review-comment">{review.comment}</p>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      <section className="products6">
        <h2>Shop More Products</h2>
        <div className="product-container6">
          <div className="product-card6" onClick={() => window.location.href = "/wallet"}>
            <img src={brikwallet} alt="Compact Wallet" />
            <h3>Wallet</h3>
            <p>$39.99</p>
          </div>

          <div className="product-card6" onClick={() => window.location.href = "/stand"}>
            <img src={bigphoneStand} alt="Phone Stand" />
            <h3>Phone Stand</h3>
            <p>$12.99</p>
          </div>

          <div className="product-card6" onClick={() => window.location.href = "/card"}>
            <img src={brikCard} alt="Brik Card" />
            <h3>Brik Card</h3>
            <p>$12.99</p>
          </div>

          <div className="product-card6" onClick={() => window.location.href = "/powerbank"}>
            <img src={batterypack} alt="Powerbank" />
            <h3>Power Bank</h3>
            <p>$20.99</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Utility;
